import { directiveSettings } from '../../utils/parse';
import { getData } from '../../utils/data';
/**
 * @module directives/action/selector
 */

/**
 * Creates selectors.
 */
export default function selectorDirective() {

  document.querySelectorAll('[data-sw-selector]').forEach(element => {

    const data = element.getAttribute('data-sw-selector'),
    settings = directiveSettings(data, {
      selector: '[data-sw-toggler]',
    }, 'selector');

    const togglers = element.querySelectorAll(settings.selector).map(el => {
      return getData(el, 'toggler');
    });

    const selectToggler = toggler => {
      for (let otherToggler of togglers) {
        if (otherToggler !== toggler) otherToggler.close();
      }
    };

    togglers.forEach((toggler) => toggler.on('open', _ => selectToggler(toggler)));
  });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/selector.js